import { OnDestroy, OnInit, AfterContentInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../../store';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
var INDRAFlightDetailsRefundsComponent = /** @class */ (function () {
    function INDRAFlightDetailsRefundsComponent(sidebarService, route, router, store, ancillariesService, bookingService, bfmStorageService, dateService, ibeAdminService, bookingSearchService, storageService) {
        this.sidebarService = sidebarService;
        this.route = route;
        this.router = router;
        this.store = store;
        this.ancillariesService = ancillariesService;
        this.bookingService = bookingService;
        this.bfmStorageService = bfmStorageService;
        this.dateService = dateService;
        this.ibeAdminService = ibeAdminService;
        this.bookingSearchService = bookingSearchService;
        this.storageService = storageService;
        this.time_to_flight = 0;
        // flight: INDRAFlight;
        this.allSubscriptions = [];
        this.availability = false;
        this.reviewFlights = false;
        this.timeToThinkFlights = false;
        this.isBookingView = false;
        this.isDupe = false;
        this.passengers$ = this.store.select(fromStore.getMiniIBEPassengers);
        this.main_section = {
            label: this.INDRA_getTranslation('bookingDetails.label.fareConditions'),
            state: 'collapsed'
        };
        this.self = this;
        this.self.isAlive = true;
        this.SECTIONS = [
            {
                label: this.INDRA_getTranslation('bookingDetails.sidebars.fareConditions.label.changes'),
                state: 'expanded',
                characteristics: []
            },
            {
                label: this.INDRA_getTranslation('bookingDetails.sidebars.fareConditions.label.cancellation'),
                state: 'expanded',
                characteristics: []
            },
        ];
        this.upgrade = false;
        this.change = false;
        this.defaultItems = {
            key: '',
            value: '',
            currency: '',
        };
        this.refundItems = this.defaultItems;
        this.changeItems = this.defaultItems;
        this.defaultText = this.INDRA_getTranslation('bookingDetails.sidebars.fareConditions.text.defaultText');
    }
    INDRAFlightDetailsRefundsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.router.url.includes('/review-your-trip'))
            this.reviewFlights = true;
        if (this.router.url.includes('/time-to-think'))
            this.timeToThinkFlights = true;
        if (this.router.url.includes('/flights') || this.router.url.includes('/flights-multicity'))
            this.availability = true;
        if (this.router.url.includes('/my-bookings/view'))
            this.isBookingView = true;
        this.passengers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                // generate generic passenger list according to type and count
                _this.passengerList = _this.ancillariesService.INDRA_generateGenericPassengerList(value);
            }
        });
        // get flight and feature object from the data obj passed into the sidebarservice
        var parameters = this.sidebarService.getSidebarParameters();
        if (parameters && parameters.length > 0) {
            this.storageService.set('sidebarRefundParams', parameters);
            parameters = parameters;
        }
        else {
            parameters = this.storageService.get('sidebarRefundParams');
        }
        if (parameters && parameters.length) {
            this.flightInfo = parameters[0].flightInfo;
            this.feature = parameters[0].feature;
        }
        this.brand = this.route.snapshot.paramMap.get('brand');
        this.bookingSubscription = this.bookingService.bookingTrip.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function () {
            if (_this.self.flightIdentifier) {
                _this.self.flight = _this.self.bookingService.INDRA_getBookedFlight(_this.self.flightIdentifier);
            }
        });
        this.paramSubscription = this.route.params.subscribe(function (params) {
            if (params.flight) {
                _this.flightIdentifier = params.flight;
                _this.flight = !_this.availability ? _this.bookingService.INDRA_getBookedFlight(params.flight) : _this.storageService.get('availabilityFlightData');
            }
            if (params.isDupe === 'true') {
                _this.isDupe = true;
            }
            _this.upgrade = params.upgrade;
            _this.change = params.change;
            _this.flightIndex = params.index;
            if (_this.upgrade) {
                _this.selectedBrand = _this.bfmStorageService.INDRA_getSelectedBrandToUpgradeCash();
            }
            else if (_this.change) {
                _this.selectedBrand = _this.bfmStorageService.INDRA_getSelectedBrandToChange()[_this.flightIndex];
                _this.flight = _this.bfmStorageService.INDRA_getSelectedFlightChange()[_this.flightIndex].details;
            }
        });
        this.populateValues();
        this.allSubscriptions.push(this.bookingSubscription);
        this.allSubscriptions.push(this.paramSubscription);
    };
    INDRAFlightDetailsRefundsComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAFlightDetailsRefundsComponent.prototype.ngAfterContentInit = function () {
        this.time_to_flight = this.INDRA_getTimeTo();
    };
    Object.defineProperty(INDRAFlightDetailsRefundsComponent.prototype, "INDRA_printTimeTo", {
        get: function () {
            var timediff = this.time_to_flight;
            var days = Math.floor(timediff / 60 / 60 / 24);
            var hours = Math.floor(timediff / 60 / 60);
            var minutes = Math.floor(timediff / 60);
            if (days > 0) {
                return days;
            }
            else if (hours > 0) {
                return hours;
            }
            else if (minutes > 0) {
                return minutes;
            }
            else {
                return 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getTimeUnitKey = function (time) {
        var timediff = time;
        var days = Math.floor(timediff / 60 / 60 / 24);
        var hours = Math.floor(timediff / 60 / 60);
        var minutes = Math.floor(timediff / 60);
        if (days > 0) {
            return 'bookingDetails.label.days';
        }
        else if (hours > 0) {
            return 'bookingDetails.label.hours';
        }
        else if (minutes > 0) {
            return 'bookingDetails.label.minutes';
        }
        else {
            return 'bookingDetails.label.now';
        }
    };
    // SIDEBAR INTERACTIONS
    /** Close sidebar and clear secondary route */
    INDRAFlightDetailsRefundsComponent.prototype.closeSidebar = function () {
        this.sidebarService.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    /** Handles close action intention **/
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_handleClose = function () {
        this.closeSidebar();
        this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_handleToggle = function (section) {
        section.state = section.state === 'expanded' ? 'collapsed' : 'expanded';
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_printFlightDate = function () {
        return this.dateService.INDRA_formatDate(this.flight.listSegment[0].departureDate, 'dddd, MMMM DD');
    };
    INDRAFlightDetailsRefundsComponent.prototype.populateValues = function () {
        var bookingTrip;
        var flightId = this.flight.idFlight;
        if (!this.availability) {
            bookingTrip = this.isDupe ? this.bfmStorageService.INDRA_getDupeBookedTrip() : this.bfmStorageService.INDRA_getActiveBookedTrip();
        }
        else {
            bookingTrip = this.storageService.get('selectedInfoTAC');
        }
        var upgradeBooking = this.selectedBrand;
        if (bookingTrip && bookingTrip['fare-information'] && Object.keys(bookingTrip['fare-information']).length > 0) {
            var fareInfo = void 0;
            if (!this.upgrade && !this.change) {
                fareInfo = bookingTrip['fare-information'][flightId];
            }
            else {
                fareInfo = upgradeBooking;
            }
            if (fareInfo) {
                var changesDescription = fareInfo['changes-description'];
                var refundsDescription = fareInfo['refunds-description'];
                if (changesDescription)
                    this.SECTIONS[0].description = this.INDRA_getTranslation(changesDescription);
                if (refundsDescription)
                    this.SECTIONS[1].description = this.INDRA_getTranslation(refundsDescription);
            }
            var changesFee = void 0;
            var refundsFee = void 0;
            if (fareInfo && fareInfo['changes-fee']) {
                changesFee = fareInfo['changes-fee'][0] || '';
            }
            if (fareInfo && fareInfo['refounds-fee']) {
                refundsFee = fareInfo['refounds-fee'][0] || '';
            }
            if (fareInfo) {
                this.changeItems = {
                    key: fareInfo.changes,
                    value: fareInfo.changes === 'FEE' && changesFee ? changesFee.amount : '',
                    currency: fareInfo.changes === 'FEE' && changesFee ? changesFee.currency : ''
                };
                this.refundItems = {
                    key: fareInfo.refunds,
                    value: fareInfo.refunds === 'FEE' && refundsFee ? refundsFee.amount : '',
                    currency: fareInfo.refunds === 'FEE' && refundsFee ? refundsFee.currency : ''
                };
                var bookingTripObject = bookingTrip['fare-information'][flightId];
                if (bookingTripObject) {
                    this.noShow = bookingTrip['fare-information'][flightId]['no-show'];
                    if (Object.is(this.noShow, 'FEE')) {
                        this.amount = bookingTrip['fare-information'][flightId]['no-show-fee']['0']['amount'];
                    }
                }
            }
        }
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getFlightDetails = function () {
        var departure = this.INDRA_getLocation(this.flight.listSegment[0].departureAirport);
        var arrival = this.INDRA_getLocation(this.INDRA_getArrivalAirport());
        var bound;
        if (this.availability) {
            return this.flight;
        }
        else {
            if (this.bfmStorageService.INDRA_getSelectedFlightChange() && this.bfmStorageService.INDRA_getSelectedFlightChange()[this.flightIndex]) {
                bound = this.bfmStorageService.INDRA_getSelectedFlightChange()[this.flightIndex].bound;
            }
            else if (this.bfmStorageService.INDRA_getBoundSelectedFlight()) {
                bound = undefined;
            }
            return { details: this.flight, departureLocation: departure, arrivalLocation: arrival, airLinesTranslation: this.bfmStorageService.activeBooking.translate.airlines, bound: bound };
        }
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getLocation = function (code) {
        if (this.availability) {
            var bookingTrip = this.storageService.get('selectedInfoTAC');
            return bookingTrip.airport.translate.locations[code];
        }
        else {
            return this.bookingService.INDRA_getLocation(code);
        }
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getArrivalAirport = function () {
        var flightsLength = this.flight.listSegment.length;
        return this.flight.listSegment[flightsLength - 1].arrivalAirport;
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getBrand = function () {
        if (!this.upgrade && !this.change) {
            if (!this.flight.fareFamily) {
                return '';
            }
            else {
                return this.reviewFlights || this.timeToThinkFlights || this.isBookingView ?
                    this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily) :
                    this.availability ? this.flight.brandCode : this.bookingService.INDRA_getBrandCode(this.flight.fareFamily);
            }
        }
        else {
            return this.availability ? this.flight.brandCode : this.selectedBrand.name;
        }
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_getTimeTo = function () {
        return Math.floor(this.dateService.INDRA_getRemainingTimeInSeconds(this.flight.listSegment[0].departureDate));
    };
    INDRAFlightDetailsRefundsComponent.prototype.INDRA_isPNRFlightsMixed = function () {
        return this.flight && this.flight.mixedCabins ? this.flight.mixedCabins : false;
    };
    return INDRAFlightDetailsRefundsComponent;
}());
export { INDRAFlightDetailsRefundsComponent };
